import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom'
import router from './router/index.js';

// components
import Notification from './components/notification';
import Navbar from './components/navbar';
import Footer from './components/footer';

// css
import logo from './logo.svg';
import './App.css';
import bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './font-awesome/css/all.css';

class App extends Component {
  render() {
    return (
      <Router basename="/pjs">
        <div>
        <Navbar/>
        {router}
        <Footer/>
        </div>
      </Router>
    );
  }
}

export default App;
